import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AreaForm from "../../../../screens/places/components/AreaForm";

export default function CitiesEdit(props) {
  const { t } = useTranslation();
  let { id } = useParams();
  return (
    <AreaForm
      resourceUrl={`/cities/${id}`}
      resourceKey="Cities"
      breadcrumbs={[{ content: t("cities.breadcrumbs.cities"), url: "/places/cities" }]}
    />
  );
}
